/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import { withNamespaces } from 'react-i18next';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { hideElementCss, showElementCss } from '../../../../utils/responsive';
import MediaQueries from '../../../../styles/Grid/MediaQueries';
import { navbar_finite_state } from '../../../../contexts/NavContext';
import { NAVBAR_IDS } from '../../../../utils/constants';
import { RegusLogo } from '../../../ui/RegusLogo';
import NavIcon from './NavIcon.svg';
import {
  buttonReset,
  listCss,
  menuSizeCss,
  regusLogoCss,
  waysToWorkCss,
  waysToWorkButtonCss,
  phoneSizeCss,
  phoneButtonCss,
  searchSizeCss,
  profileSizeCss,
  profileButtonCss,
  loginCss,
  accountbtnCss,
  verticalLineCss,
  flexWrapperCss,
  regusLogoWrapperCss,
  searchButtonCss,
  hoverStyleHamburguerCss,
  iconCloserSizeCss,
  containerAnimationCss,
  circleHoverCss,
  animationContainerCss,
  flexContainer,
  hoverStyleIconCss,
  activeCss,
  activeWaysToWorkCss,
  searchLocationTextCss,
  alignRight,
  hideElement,
  phoneNumberHolder,
  phoneNumberSticky,
} from './index.styles';
import { get } from 'lodash';

const NewNav = ({
  clickedItem,
  closeModal,
  isModalOpen,
  language,
  membership,
  onClickItem,
  t,
  closeText,

  waysToWorkText,
  callusInfo,
  isSticky,
  closeIcon,
}) => {
  if (!closeText) {
    closeText = 'Close';
  }

  if (isModalOpen && clickedItem === navbar_finite_state.LOCATION) {
    return null;
  }
  if (
    isModalOpen &&
    clickedItem !== navbar_finite_state.SEARCH &&
    clickedItem !== navbar_finite_state.SEARCH_NAV
  ) {
    return (
      <div
        css={[
          flexWrapperCss,
          clickedItem === navbar_finite_state.MY_ACCOUNT && alignRight,
          isModalOpen && showElementCss(MediaQueries.lgAndUp, 'flex'),
        ]}
      >
        <button
          id={isModalOpen ? NAVBAR_IDS.CLOSE_ACTIVE : NAVBAR_IDS.CLOSE}
          onClick={closeModal}
          data-id={navbar_finite_state.CLOSE}
          aria-label=  {t('Close')}
          css={[
            buttonReset,
            flexWrapperCss,
            // containerAnimationCss(isModalOpen),
          ]}
        >
          <span>
            {/* <i className="icon-closer" /> */}
            {closeIcon}
          </span>
          <span className="translate-text-" css={loginCss}>           
            {t('Close')}
          </span>
        </button>
      </div>
    );
  }

  return (
    <React.Fragment>
      <div
        css={[
          flexWrapperCss,
          isModalOpen && showElementCss(MediaQueries.lgAndUp, 'flex'),
        ]}
      >
        <button
          id={
            isModalOpen
              ? NAVBAR_IDS.WAYS_TO_WORK_ACTIVE
              : NAVBAR_IDS.WAYS_TO_WORK
          }
          onClick={() => {
            onClickItem({
              target: {
                dataset: { id: navbar_finite_state.WAYS_TO_WORK },
              },
            });
          }}
          data-id={navbar_finite_state.WAYS_TO_WORK}
          aria-label={waysToWorkText}
          css={[
            buttonReset,
            flexWrapperCss,
            waysToWorkButtonCss,
            // containerAnimationCss(isModalOpen),
            clickedItem === navbar_finite_state.WAYS_TO_WORK &&
              activeWaysToWorkCss(isModalOpen),
          ]}
        >
          <span>
            <span
              css={[menuSizeCss, hoverStyleHamburguerCss]}
              className="icon-ways-to-work"
            >
              <img alt="nav icon" src={NavIcon} />
            </span>
            {/* <span css={circleHoverCss} className="circle-hover" /> */}
          </span>
          <span
            className="translate-text"
            css={[waysToWorkCss, hideElementCss(MediaQueries.sm)]}
          >
            {waysToWorkText}
          </span>
        </button>
      </div>

      <div
        css={[
          regusLogoWrapperCss,
          // isModalOpen && showElementCss(MediaQueries.lgAndUp),
        ]}
      >
        <a
          aria-label="regus logo"
          css={[buttonReset, flexWrapperCss]}
          href={`/${language.toLowerCase()}`}
          id={NAVBAR_IDS.HOME}
        >
          <RegusLogo
            customCss={regusLogoCss}
            // type={isModalOpen && LOGO_TYPES.WHITE}
          />
        </a>
      </div>
      <div>
        <ul css={listCss}>
          <li
            css={[
              (clickedItem === navbar_finite_state.SEARCH ||
                clickedItem === navbar_finite_state.SEARCH_NAV) &&
                hideElement,
              phoneNumberHolder,
            ]}
          >
            <button
              id={isModalOpen ? NAVBAR_IDS.CONTACT_ACTIVE : NAVBAR_IDS.CONTACT}
              onClick={() => {
                if (isSticky && callusInfo.number) {
                  window.open('tel:' + callusInfo.number, '_self');
                } else {
                  onClickItem({
                    target: {
                      dataset: { id: navbar_finite_state.CONTACT },
                    },
                  });
                }
              }}
              data-id={navbar_finite_state.CONTACT}
              aria-label="Contact"
              css={[
                buttonReset,
                flexWrapperCss,
                phoneButtonCss,
                phoneNumberHolder,
                //
                // containerAnimationCss(isModalOpen),
                clickedItem === navbar_finite_state.CONTACT && activeCss,
                isSticky && phoneNumberSticky,
              ]}
            >
              <div
                className="mobile-view-phone-number"
                css={[!isModalOpen && showElementCss(MediaQueries.sm)]}
              >
                <span>
                  <i
                    css={[phoneSizeCss, hoverStyleIconCss]}
                    className="icon-phone"
                  />
                  <span css={circleHoverCss} className="circle-hover" />
                </span>
              </div>
              <div
                className="desktop-view-phone-number"
                css={[!isModalOpen && showElementCss(MediaQueries.lgAndUp)]}
              >
                <span className="cust-call-no">
                  <i
                    css={[phoneSizeCss, hoverStyleIconCss]}
                    className="icon icon-contact"
                  />
                </span>
                <span className="cust-call-us">{callusInfo.text}</span>
                <span>{callusInfo.number}</span>
              </div>
            </button>
          </li>

          <li
            css={[
              flexContainer,
              // !isModalOpen && hideElementCss(MediaQueries.sm),
            ]}
          >
            {isModalOpen ? (
              <button
                id={isModalOpen ? NAVBAR_IDS.CLOSE_ACTIVE : NAVBAR_IDS.CLOSE}
                onClick={closeModal}
                data-id={navbar_finite_state.CLOSE}
                aria-label=  {t('Close')}
                css={[
                  buttonReset,
                  flexWrapperCss,
                  // containerAnimationCss(isModalOpen),
                ]}
              >
                <span css={animationContainerCss}>
                  <i
                    css={[profileSizeCss, iconCloserSizeCss, hoverStyleIconCss]}
                    className="searchclose_ic icon-closer"
                  />
                  <span css={circleHoverCss} className="circle-hover" />
                </span>
                <span className=" translate-text" css={loginCss}>
                  {t('Close')}
                </span>
              </button>
            ) : (
              <button
                id={
                  isModalOpen
                    ? NAVBAR_IDS.MY_ACCOUNT_ACTIVE
                    : NAVBAR_IDS.MY_ACCOUNT
                }
                onClick={onClickItem}
                data-id={navbar_finite_state.MY_ACCOUNT}
                aria-label="My Account"
                css={[
                  buttonReset,
                  flexWrapperCss,
                  profileButtonCss,
                  // containerAnimationCss(isModalOpen),
                ]}
              >
                <span>
                  <i
                    css={[profileSizeCss, hoverStyleIconCss]}
                    className="icon-profile"
                  />
                </span>
                <span
                  className="translate-text"
                  css={[
                    loginCss,
                    accountbtnCss,
                    showElementCss(MediaQueries.lg),
                    showElementCss(MediaQueries.xl),
                  ]}
                >
                  {membership}
                </span>
              </button>
            )}
          </li>
        </ul>
      </div>
    </React.Fragment>
  );
};

NewNav.defaultProps = {
  language: '',
  t: key => key,
};

export default withNamespaces()(NewNav);
